import React from 'react';

const Spinner = ({ 
  animation = 'border', 
  size = 'md', 
  variant = 'primary',
  className = '',
  role = 'status',
  ...props 
}) => {
  const sizes = {
    sm: 'w-4 h-4 border-2',
    md: 'w-8 h-8 border-3',
    lg: 'w-12 h-12 border-4',
  };
  
  const variants = {
    primary: 'border-blue-600',
    secondary: 'border-gray-600',
    success: 'border-green-600',
    danger: 'border-red-600',
    warning: 'border-yellow-500',
    info: 'border-cyan-600',
    light: 'border-gray-300',
    dark: 'border-gray-800',
  };

  if (animation === 'grow') {
    return (
      <div 
        className={`inline-block rounded-full ${sizes[size]} ${variants[variant]} animate-ping ${className}`}
        role={role}
        {...props}
      >
        <span className="sr-only">Loading...</span>
      </div>
    );
  }

  return (
    <div 
      className={`inline-block rounded-full ${sizes[size]} border-t-transparent ${variants[variant]} animate-spin ${className}`}
      role={role}
      {...props}
    >
      <span className="sr-only">Loading...</span>
    </div>
  );
};

export default Spinner;